module.exports = __webpack_public_path__ + "static/media/neighbourhood-01-golf.ce7e82a3.jpg";